import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { utilities } from '@weatherbug/common';
import { reduxConnect } from '../../../common';
import { translate } from '../../../common/translation/translate';
import { WeatherDetailsListItem,
    WeatherDetailsCellContainerLeft,
    WeatherDetailsCellContainerRight,
    WeatherDetailsCellLabel,
    WeatherDetailsCellValue } from '../weatherDetailsStyledComponents';
import { isValidDisplayValue } from './formatObsData';
const { units } = utilities;
const defaultObsValue = '--';

const mapStoreStateToProps = (storeState) => {
    const { selectedStationObservations, units: storeStateUnits } =  storeState || {};
    const surfaceObservations = selectedStationObservations?.data?.wsobs?.so;
    const { wct: windChill, rd: dailyRain } = surfaceObservations ?? {};
    const { tempUnit } = storeStateUnits || {};

    return {
        windChill,
        dailyRain,
        tempUnit,
        lengthUnit: tempUnit
    };
};

const mapDispatchToProps = {
};
// eslint-disable-next-line react/display-name
export const WindChillAndDailyRainView = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ windChill, dailyRain, tempUnit, lengthUnit }) => {

    const tempUnitAbbrev = units.temperatureUnitAbbreviations[tempUnit];
    const lengthUnitAbbrev = units.lengthUnitAbbreviations[lengthUnit];

    const displayWindChill = windChill >= 0 && isValidDisplayValue(windChill) ? `${windChill}${tempUnitAbbrev}` : defaultObsValue;

    const displayDailyRain = dailyRain >= 0 && isValidDisplayValue(dailyRain) ? `${dailyRain}${lengthUnitAbbrev}` : defaultObsValue;

    return (
        <WeatherDetailsListItem key='windchill-d.rain'>
            <WeatherDetailsCellContainerLeft>
                <WeatherDetailsCellLabel>{translate('windchill')}</WeatherDetailsCellLabel>
                <WeatherDetailsCellValue>{displayWindChill}</WeatherDetailsCellValue>
            </WeatherDetailsCellContainerLeft>
            <WeatherDetailsCellContainerRight>
                <WeatherDetailsCellLabel>{translate('dailyRain')}</WeatherDetailsCellLabel>
                <WeatherDetailsCellValue>{displayDailyRain}</WeatherDetailsCellValue>
            </WeatherDetailsCellContainerRight>
        </WeatherDetailsListItem>
    );
}));

WindChillAndDailyRainView.propTypes = {
    windChill: PropTypes.string,
    dailyRain: PropTypes.string,
    tempUnit: PropTypes.number,
    lengthUnit: PropTypes.number
};

WindChillAndDailyRainView.displayName = 'WindChillAndDailyRainView';
